
import ModalEducateUsers from '@marketplace/components/modals/modal-educate-users.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'ModalHowOCWorks',

    components: {
        ModalEducateUsers,
    },

    computed: {
        ...mapGetters('global', ['userCountry']),

        // Return true for core markets --> NL/BE/DE, false for all other markets
        isInCoreCountry() {
            return ['NL', 'BE', 'DE'].includes(this.userCountry.toUpperCase())
        },
        steps() {
            const steps = [
                {
                    title: this.$t('labels.explore_brands'),
                    description: this.$t('labels.explore_brands_description'),
                    backgroundColor: '#42594f',
                    imageUrl:
                        require('~assets/images/user-education/how-works-modal-image-01.svg'),
                },
                {
                    title: this.$t('labels_track_orders_title'),
                    description: this.$t('labels_track_orders_description'),
                    backgroundColor: '#42594f',
                    imageUrl:
                        require('~assets/images/user-education/how-works-modal-image-02.svg'),
                },
            ]

            if (this.isInCoreCountry) {
                steps.push({
                    title: this.$t('labels.tica_shopping_experience_title'),
                    description: this.$t(
                        'labels.tica_shopping_experience_description'
                    ),
                    backgroundColor: '#42594f',
                    imageUrl:
                        require('~assets/images/user-education/how-works-modal-image-03.svg'),
                })
            }

            return steps
        },
    },
}
